import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import moment from "moment";
import { Checkbox } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import Lottie from "lottie-react";
import reloadpage from "../../reloadpage.json";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { Button, Modal, Divider, Input, Dropdown, Space } from "antd";
import add from "../../Images/add.png";
import AutoTasksFirstTable from "../AutoTasksComponents/AutoTasksFirstTable";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
//import { MyUrl } from "../../../App";
import "ag-grid-enterprise";
var SendDataToFirstTable = [];
var setDataOfTaskLog5 = [];

function AutoTasks() {
  //when pick today
  const Today = moment().add("days").format("YYYY-MM-DD");

  var startDate = Today;
  var endDate = Today;

  const [height, width] = useWindowSize();
  const [Loading, setLoading] = useState(false);
  const [chooceCompanies, setChooceCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  var LastDayInMonth = moment(LastDayInMonth)
    .endOf("month")
    .format("YYYY-MM-DD");

  var FirstDayInMonth = moment(FirstDayInMonth)
    .startOf("month")
    .format("YYYY-MM-DD");

  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const IdsToGetData = []; //chooceCompanies.map((id) => "," + String(id)).join("");

  // ag grid section
  const gridRef = useRef(); // Optional - for accessing Grid's API

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Task Date",
      flex: width > 766 ? 1 : null,
      field: "taskDate",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Task Content",
      flex: width > 766 ? 1 : null,
      field: "taskContent",
      filter: "agNumberColumnFilter",
      minWidth: 1500,
      headerClass: "my-header-class",
    },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  // Example using Grid's API
  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    "rag-amber-outer": function (params) {
      return params.value === 2004;
    },
    "rag-red-outer": function (params) {
      return params.value === 2000;
    },
  };
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === setDataOfTaskLog5.length
        ? "bottom-row"
        : "";
    },
  };

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  useEffect(() => {
    // This code will run only when myVariable changes
    console.log(`startDate changed to ${startDate} ---- ${endDate}`);
  }, [startDate, endDate]);
  const frameworkComponents = {
    actionsCellRenderer: ActionsCellRenderer,
  };

  //End ag grid section

  //Select Days
  const [days, setDays] = React.useState(0);
  const handleChangeDays = (event) => {
    setDays(event.target.value);
  };
  //End select Days

  const getCustomersData1 = () => {
    setIsLoading(true);
    try {
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetSeats?clearCacheForUpload=false`
        )
        .then((res) => {
          const data = res.data;
          for (let i = 0; i < data.length; i++) {
            IdsToGetData.push(data[i].id);
            setChooceCompanies((prevCompanies) => [
              ...prevCompanies,
              data[i].id,
            ]);
          }
          getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {
          setIsLoading(false);
        });
    } catch (err) {}
  };

  const items = localStorage.getItem("Token");
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  const [ObjectForChange, setObjectForChange] = useState({});

  const getCustomersData = (startDate, endDate) => {
    try {
      setLoading(false);
      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetAutoTasks`,
          // `https://dsp-api.o2rintelligence.com/api/Dashboard/GetDashboardReport?dateFrom=${startDate}&dateTo=${endDate}&seatids=${chooceCompanies.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${aa}`,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          console.log(data);
          SendDataToFirstTable = [];

          for (let i = 0; i < data.length; i++) {
            SendDataToFirstTable.push(data[i]);
          }
        })
        .catch((error) => {})
        .finally(() => {
          console.log(SendDataToFirstTable);
          setLoading(true);
        });
    } catch (err) {}
  };

  useEffect(() => {
    setChooceCompanies([]);
    getCustomersData1();
    const items = localStorage.getItem("Token");
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    console.log("Edit");
    EditSource();
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    console.log("cancel");
    setIsModalOpen(false);
  };

  const [Targeting, setTargeting] = React.useState();
  const [Geo, setGeo] = React.useState();

  const handleChangeTargeting = (event) => {
    setObjectForChange((prevState) => ({
      ...prevState,
      targeting: event.target.value,
    }));
  };

  const handleChangeGeo = (event) => {
    setObjectForChange((prevState) => ({
      ...prevState,
      geo: event.target.value,
    }));
  };

  const [dataFromChild, setDataFromChild] = useState(null);

  const EditSource = async (event) => {
    var newObj = {
      id: 0,
      taskName: taskName1,
      seatId: seatId1,
      interval: interval1,
      startDate: startDate1,
      endDate: endDate1,
    };
    console.log(newObj);
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateSource`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log(response);
      getCustomersData(startDate, endDate);
      //CallData1();
    } catch (error) {
      console.log("error in Edit Source");
    }
  };

  //Task Section

  const [isModalOpen5, setIsModalOpen5] = useState(false);

  const [taskName5, settaskName5] = useState("");
  const [seatName5, setseatName5] = useState("");
  const [AutoTaskLog, setAutoTaskLog] = useState("");
  const [isLoading5, setisLoading5] = useState(false);
  //const [DataOfTaskLog5, setDataOfTaskLog5] = useState("");

  const handleOk5 = () => {
    console.log("Task Log");
    setIsModalOpen5(AutoTaskLog);
  };
  const handleCancel5 = () => {
    console.log("cancel");
    setIsModalOpen5(false);
  };

  const reveiveDataForTaskLog = (data) => {
    TaskLogCall(data.id);
    settaskName5(data.taskName);
    setseatName5(data.seatName);
    console.log(data.dataToSendTaskLog);
    setIsModalOpen5(data.dataToSendTaskLog);
    setAutoTaskLog(data.id);
    console.log(data);
  };

  const TaskLogCall = (TaskId) => {
    try {
      setisLoading5(false);
      const items = localStorage.getItem("Token");
      const trimmedMyaa = items.substring(1, items.length - 1);
      const aa = trimmedMyaa.replace("?jwt=", "");
      console.log("TaskLogCall");
      console.log(AutoTaskLog);

      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/GetTaskLogs?taskId=${TaskId}`,
          {
            headers: {
              Authorization: `Bearer ${aa}`,
            },
          }
        )
        .then((res) => {
          const data = res.data;
          console.log(data);

          for (let i = 0; i < data.length; i++) {
            setDataOfTaskLog5.push(data[i]);
          }
          console.log(setDataOfTaskLog5);
          //getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {
          setisLoading5(true);
        });
    } catch (err) {}
  };

  function OpenModalTaskLog() {
    return (
      <div>
        <Modal
          okText="Ok"
          width={"70%"} // Set the width of the Modal
          title={"Task Logs: " + taskName5 + " - " + seatName5}
          open={isModalOpen5}
          onOk={handleOk5}
          onCancel={handleCancel5}
        >
          {isLoading5 ? (
            <div>
              <div style={{ paddingTop: 30, paddingBottom: 30 }}>
                <div style={containerStyle}>
                  <div style={gridStyle} className="ag-theme-alpine">
                    {/* <span style={{ color: "#1a1523", fontSize: 18 }}>
                      Source Management
                    </span> */}
                    <AgGridReact
                      cellClassRules={ragCellClassRules}
                      ref={gridRef} // Ref for accessing Grid's API
                      rowData={setDataOfTaskLog5} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
                      columnDefs={columnDefs} // Column Defs for Columns
                      defaultColDef={defaultColDef} // Default Column Properties
                      animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                      rowSelection="multiple" // Options - allows click selection of rows
                      onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                      onGridReady={onGridReady}
                      gridOptions={gridOptions}
                      suppressScrollOnNewData={true}
                      getRowHeight={getRowHeight}
                      domLayout="autoHeight"
                      pagination={true}
                      paginationPageSize={10}
                      frameworkComponents={frameworkComponents}
                    />
                  </div>{" "}
                </div>{" "}
                <style>
                  {`
                    .ag-theme-alpine .ag-root-wrapper {
                      border: none;
                    }
                  `}
                  {`
                    .my-header-class {
                      background-color: white;
                    }
                  `}
                </style>
              </div>
            </div>
          ) : (
            <div>
              <h1>Loading...</h1>
            </div>
          )}
        </Modal>
      </div>
    );
  }
  //End Task Section

  //Delete Section
  const [Id3, SetId3] = useState("");
  const handleChangeId3 = (event) => {
    SetId3(event.target.value);
    console.log(Id3);
  };

  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const handleOk3 = () => {
    console.log("Delete");
    DeleteAutoTask();
    setIsModalOpen3(false);
  };
  const handleCancel3 = () => {
    console.log("cancel");
    setIsModalOpen3(false);
  };

  const [ObjectForDelete, setObjectForDelete] = useState();
  const [AutoTaskDeleteName, setAutoTaskDeleteName] = useState("");

  const receiveDataFromChildForDelete = (data) => {
    console.log(data);
    setIsModalOpen3(data.dataToSendForDelete);
    setObjectForDelete(data.id);
    setAutoTaskDeleteName(data.taskName);
    console.log(ObjectForDelete);
    console.log("We have one");
  };

  console.log(ObjectForDelete);

  const DeleteAutoTask = async (event) => {
    try {
      //Array = Array.filter((item) => item !== timeTaken);

      const response = await axios.delete(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/DeleteAutoTask?id=${ObjectForDelete}`,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("Created");
      getCustomersData(startDate, endDate);
    } catch (error) {
      console.log("error in Create Source");
    }
  };

  function OpenModalDeleteFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Delete"
          width={"50%"} // Set the width of the Modal
          title="Delete Auto Task"
          open={isModalOpen3}
          onOk={handleOk3}
          onCancel={handleCancel3}
        >
          <p>{AutoTaskDeleteName}</p>
        </Modal>
      </div>
    );
  }
  //End delete Section
  //Creat Section
  const [Id1, SetId1] = useState("");
  const [taskName1, settaskName1] = useState("");
  const [seatId1, setseatId1] = useState("1");
  const [interval1, setinterval1] = useState("hourly");
  const [startDate1, setstartDate1] = useState(null);
  const [endDate1, setendDate1] = useState("");

  const handleChangeId1 = (event) => {
    SetId1(event.target.value);
    console.log(Id1);
  };
  const handleChangetaskName1 = (event) => {
    settaskName1(event.target.value);
    console.log(taskName1);
  };
  const handleChangeseatId1 = (event) => {
    setseatId1(event.target.value);
    console.log(seatId1);
  };
  const handleChangeinterval1 = (event) => {
    setinterval1(event.target.value);
    console.log(interval1);
  };
  const handleChangestartDate1 = (event) => {
    const formattedDate = event.format("YYYY-MM-DD");
    setstartDate1(formattedDate);
    console.log(startDate1);
  };
  const handleChangeendDate1 = (event) => {
    const formattedDate = event.format("YYYY-MM-DD");
    setendDate1(formattedDate);
    console.log(endDate1);
  };

  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const handleOk1 = () => {
    CreateNewSource();
    console.log("Create");
    setIsModalOpen1(false);
    setstartDate1("");
    setendDate1("");
    settaskName1("");
  };
  const handleCancel1 = () => {
    setstartDate1("");
    setendDate1("");
    settaskName1("");

    console.log("cancel");
    setIsModalOpen1(false);
  };

  const CreateNewSource = async (event) => {
    var newObj = {
      id: 0,
      taskName: taskName1,
      seatId: seatId1,
      interval: interval1,
      startDate: startDate1,
      endDate: endDate1,
    };
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateOrCreateAutoTask`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("Created");
      getCustomersData(startDate, endDate);
    } catch (error) {
      console.log("error in Create Source");
    }
  };
  console.log(startDate1);
  function OpenModalCreateFunc() {
    return (
      <div>
        {" "}
        <Modal
          okText="Create"
          width={"50%"} // Set the width of the Modal
          title="Create new auto task"
          open={isModalOpen1}
          onOk={handleOk1}
          onCancel={handleCancel1}
        >
          <div style={{}}>
            <a style={{ color: "black" }}>Auto task name</a>
            <Input
              style={{ height: "55px" }}
              placeholder="Auto task name"
              value={taskName1}
              onChange={handleChangetaskName1}
            />
            <br></br>
            <br></br>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Seat</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={seatId1}
                  label="Seat"
                  onChange={handleChangeseatId1}
                >
                  <MenuItem value={"3"}>Shauking</MenuItem>
                  <MenuItem value={"1"}>O2R</MenuItem>
                  <MenuItem value={"4"}>Oshi</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <br></br>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Interval</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={interval1}
                label="Interval"
                onChange={handleChangeinterval1}
              >
                <MenuItem value={"half_hour"}>Evry 30 minutes</MenuItem>
                <MenuItem value={"hourly"}>Every Hour</MenuItem>
                <MenuItem value={"every_2_hours"}>Every 2 Hours</MenuItem>
                <MenuItem value={"every_4_hours"}>Every 4 Hours</MenuItem>
                <MenuItem value={"every_12_hours"}>Every 12 Hours</MenuItem>
                <MenuItem value={"weekly"}>Weekly</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
            }}
          >
            <div>
              <h1 style={{ fontSize: 20 }}>Start Date</h1>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="From Date"
                  inputFormat="YYYY-MM-DD"
                  value={startDate1}
                  onChange={handleChangestartDate1}
                  renderInput={(params) => <TextField {...params} />}

                  // onChange={(newValue) =>
                  //   setstartDate1(
                  //     `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`
                  //   )
                  // }
                />
              </LocalizationProvider>
            </div>
            <div>
              <h1 style={{ fontSize: 20 }}>End Date</h1>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="To Date"
                  inputFormat="YYYY-MM-DD"
                  value={endDate1}
                  onChange={handleChangeendDate1}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>
          <br></br>
          <br></br>
        </Modal>
      </div>
    );
  }
  //End creat Section

  //Edit section

  const [Id2, SetId2] = useState("");
  const [taskName2, settaskName2] = useState("");
  const [seatId2, setseatId2] = useState("");
  const [interval2, setinterval2] = useState("");
  const [startDate2, setstartDate2] = useState("");
  const [endDate2, setendDate2] = useState("");

  const handleChangeId2 = (event) => {
    SetId2(event.target.value);
    console.log(Id2);
  };
  const handleChangetaskName2 = (event) => {
    settaskName2(event.target.value);
    console.log(taskName2);
  };
  const handleChangeseatId2 = (event) => {
    setseatId2(event.target.value);
    console.log(seatId2);
  };
  const handleChangeinterval2 = (event) => {
    setinterval2(event.target.value);
    console.log(interval2);
  };
  const handleChangestartDate2 = (event) => {
    const formattedDate = event.format("YYYY-MM-DD");
    setstartDate2(formattedDate);
    console.log(startDate2);
  };
  const handleChangeendDate2 = (event) => {
    const formattedDate = event.format("YYYY-MM-DD");
    setendDate2(formattedDate);
    console.log(endDate2);
  };

  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const handleOk2 = () => {
    EditAutoTask();
    console.log("Edit");
    setIsModalOpen2(false);
  };
  const handleCancel2 = () => {
    console.log("cancel");
    setIsModalOpen2(false);
  };

  const receiveDataFromChild = (data) => {
    // const [endDate2, setendDate2] = useState("");

    //const replacedDate = data.startDate.replace(/-/g, "/");

    const dateParts = data.startDate.split("-");
    const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;

    setIsModalOpen2(data.dataToSend);
    console.log(data.id);
    console.log(data.taskName);
    console.log(data.startDate);
    SetId2(data.id);
    settaskName2(data.taskName);
    setseatId2(String(data.seatId));
    setinterval2(data.interval);
    setstartDate2(data.startDate);
    setendDate2(data.endDate);
    console.log("We have one");
  };

  const EditAutoTask = async (event) => {
    var newObj = {
      id: Id2,
      taskName: taskName2,
      seatId: seatId2,
      interval: interval2,
      startDate: startDate2,
      endDate: endDate2,
    };
    try {
      //Array = Array.filter((item) => item !== timeTaken);
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateOrCreateAutoTask`,
        newObj,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
          //cancelToken: source.token,
        }
      );
      console.log("Created");
      getCustomersData(startDate, endDate);
    } catch (error) {
      console.log("error in Create Source");
    }
  };
  console.log(startDate1);
  function OpenModalEditAutoTask() {
    return (
      <div>
        {" "}
        <Modal
          okText="Edit"
          width={"50%"} // Set the width of the Modal
          title="Edit Auto Task"
          open={isModalOpen2}
          onOk={handleOk2}
          onCancel={handleCancel2}
        >
          <div style={{}}>
            <a style={{ color: "black" }}>Auto task name</a>
            <Input
              style={{ height: "55px" }}
              placeholder="Auto task name"
              value={taskName2}
              onChange={handleChangetaskName2}
            />
            <br></br>
          </div>
          <br></br>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Seat</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={seatId2}
                label="Interval"
                onChange={handleChangeseatId2}
              >
                <MenuItem value={"1"}>O2R</MenuItem>
                <MenuItem value={"3"}>Shauking</MenuItem>
                <MenuItem value={"4"}>Oshi</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <br></br>

          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Interval</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={interval2}
                label="Interval"
                onChange={handleChangeinterval2}
              >
                <MenuItem value={"half_hour"}>Evry 30 minutes</MenuItem>
                <MenuItem value={"hourly"}>Every Hour</MenuItem>
                <MenuItem value={"every_2_hours"}>Every 2 Hours</MenuItem>
                <MenuItem value={"every_4_hours"}>Every 4 Hours</MenuItem>
                <MenuItem value={"every_12_hours"}>Every 12 Hours</MenuItem>
                <MenuItem value={"weekly"}>Weekly</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <br></br>
          <br></br>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
            }}
          >
            <div>
              <h1 style={{ fontSize: 20 }}>Start Date</h1>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  defaultValue={dayjs(startDate2)}
                  label="From Date"
                  inputFormat={startDate2}
                  //value={startDate2}
                  onChange={handleChangestartDate2}
                  renderInput={(params) => <TextField {...params} />}

                  // onChange={(newValue) =>
                  //   setstartDate1(
                  //     `${newValue.$y}-${newValue.$M + 1}-${newValue.$D}`
                  //   )
                  // }
                />
              </LocalizationProvider>
            </div>
            <div>
              <h1 style={{ fontSize: 20 }}>End Date</h1>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  defaultValue={dayjs(endDate2)}
                  label="From Date"
                  inputFormat={endDate2}
                  //value={startDate2}
                  onChange={handleChangeendDate2}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>
          <br></br>
          <br></br>
        </Modal>
      </div>
    );
  }

  //End edit section

  //State section
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [State4, setState4] = useState("");
  const [taskName4, settaskName4] = useState("");
  const [StateId4, setStateId4] = useState("");

  const handleChangetaskName4 = (event) => {
    settaskName4(event.target.value);
    console.log(taskName4);
  };

  const handleOk4 = () => {
    console.log(State4);
    console.log("1");

    if (State4 === "stop") {
      console.log("1");

      ChangeStateToStart();
    } else if (State4 === "active") {
      console.log("2");

      ChangeStateToStop();
    }
    console.log("Task Log");
    setIsModalOpen4(false);
  };
  const handleCancel4 = () => {
    console.log("cancel");
    setIsModalOpen4(false);
  };

  const reveiveDataForState = (data) => {
    setIsModalOpen4(data.dataToSendState);
    setState4(data.state);
    settaskName4(data.taskName);
    setStateId4(data.id);
    console.log(data);
  };

  const ChangeStateToStop = () => {
    try {
      const items = localStorage.getItem("Token");
      const trimmedMyaa = items.substring(1, items.length - 1);
      const aa = trimmedMyaa.replace("?jwt=", "");

      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/ChangeStateAutoTask?id=${StateId4}&stop=true`,
          {
            headers: {
              Authorization: `Bearer ${aa}`,
            },
          }
        )
        .then((res) => {
          getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {});
    } catch (err) {}
  };

  const ChangeStateToStart = () => {
    try {
      const items = localStorage.getItem("Token");
      const trimmedMyaa = items.substring(1, items.length - 1);
      const aa = trimmedMyaa.replace("?jwt=", "");

      axios
        .get(
          `https://dsp-api.o2rintelligence.com/api/Dashboard/ChangeStateAutoTask?id=${StateId4}&stop=false`,
          {
            headers: {
              Authorization: `Bearer ${aa}`,
            },
          }
        )
        .then((res) => {
          getCustomersData(startDate, endDate);
        })
        .catch((error) => {})
        .finally(() => {});
    } catch (err) {}
  };

  function OpenModalState() {
    return (
      <div>
        {" "}
        <Modal
          okText="Yes"
          width={"50%"} // Set the width of the Modal
          title="Confirmation"
          open={isModalOpen4}
          onOk={handleOk4}
          onCancel={handleCancel4}
        >
          {State4 === "stop" ? (
            <h4>Are you sure you want to START the task {taskName4}?</h4>
          ) : (
            <h4>Are you sure you want to STOP the task {taskName4}?</h4>
          )}
        </Modal>
      </div>
    );
  }

  //End state section

  return (
    <div
      style={{
        display: "flex", // width > 766 ? "flex" : "",
        flexGrow: 1,
      }}
    >
      <div style={{ width: "100%" }}>
        {Loading ? (
          <>
            <AutoTasksFirstTable
              onSendDataForState={reveiveDataForState}
              onSendDataForTaskLog={reveiveDataForTaskLog}
              onSendDataForDelete={receiveDataFromChildForDelete}
              onSendData={receiveDataFromChild}
              SendDataToFirstTable={SendDataToFirstTable}
              startDate={startDate}
              endDate={endDate}
            />

            <div
              style={{
                justifyContent: "flex-end",
                display: "flex",
                height: 80,
              }}
            >
              <img
                src={add}
                style={{ width: 80, cursor: "pointer", paddingRight: 40 }}
                onClick={() => {
                  setIsModalOpen1(true);
                }}
              ></img>
            </div>
            <div style={{ flex: 0, display: "flex" }}>
              {OpenModalCreateFunc()}
              {OpenModalDeleteFunc()}
              {OpenModalTaskLog()}
              {OpenModalEditAutoTask()}
              {OpenModalState()}
            </div>
          </>
        ) : (
          <div
            style={{
              flex: 1,
              height: 500,
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Skeleton
              animation="wave"
              width={window.innerWidth}
              height={"100%"}
              borderRadius={100}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const ActionsCellRenderer = (props) => {
  const handleButtonClick = () => {
    // Add your button click logic here
    console.log(`Button clicked for row with ID: ${props.data.id}`);
  };

  return <button onClick={handleButtonClick}>Click Me</button>;
};
export default withRouter(AutoTasks);
